import { service } from '@ember/service';
import JSONAPIAdapter from '@ember-data/adapter/json-api';

export const MESSAGING_APPLICATION_PLATFORM = 'web';
export const MESSAGING_CONTENT_TYPE = 'application/vnd.api+json';

export default class MessagingBase extends JSONAPIAdapter {
  @service messaging;

  get headers() {
    return {
      'Api-Version': this.messaging.apiVersion,
      'Content-Type': MESSAGING_CONTENT_TYPE,
      'X-Access-Token': this.messaging.token,
      'X-Application-Platform': MESSAGING_APPLICATION_PLATFORM,
    };
  }

  get host() {
    return this.messaging.messagingApiUrl || '';
  }

  pathForType(type) {
    return super.pathForType(type).replace('messaging-', '');
  }
}
